<!-- This component acts as a input field where users can be selected 
    There will be an input section where you will type the user and it will filter out the users and give you the user details
    This will be a flexible component and will return you user details everytime a user selected -->

<template>
    <div class="p-fluid">
        <label v-if="label" :for="label">{{ props.label }}:</label>
        <autocomplete v-model="selectedUser" :id="label" :suggestions="users" :loading="loading" optionLabel="fullname" placeholder="Start typing user's email..." dropdown @item-select="userSelected" @complete="filterUsers" class="mb-1" />
    </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { storeToRefs } from 'pinia';

import { userStore } from '../../../store/global-stores';

const emit = defineEmits(['user-selected', 'update:modelValue']);

// Both props are not mandatory
const props = defineProps({
    label: String,
    modelValue: Number,
});

// Store states
const { params, users } = storeToRefs(userStore);

// Component states
const loading = ref(false);
const selectedUser = ref(null);

// Computed properties
const selectedUsersDetails = computed(() => {
    const user = selectedUser.value;
    return {
        id: user.id,
        fullname: user.name + ' ' + user.surname,
        email: user.email,
    };
});

watch(
    () => props.modelValue,
    () => {
        if (!props.modelValue) {
            selectedUser.value = null;
        }
    }
);

onMounted(() => {
    // Initially it will load 10 users by default params
    loadUsers();
});

const loadUsers = async () => {
    loading.value = true;
    await userStore.fetchAllUsers(params.value);
    loading.value = false;
};

const userSelected = () => {
    // Emit out event of selected user details
    emit('user-selected', selectedUsersDetails.value);
    // After user is selected clear the modelvalue
    // selectedUser.value = null;
    emit('update:modelValue', selectedUser.value?.id);
};
const filterUsers = async (event) => {
    // Filter string will be on query so use that in params.name to filter users
    params.value.email = event.query;
    await loadUsers();
};
</script>
